define('bundles/referrals',['require','bundles/common-ui','sections/referrals/Podio.UI.Referrals.Signup','sections/referrals/Podio.UI.Referrals.Teaser','sections/referrals/Podio.UI.Referrals.Landing'],function(require) {

  require('bundles/common-ui');
  require('sections/referrals/Podio.UI.Referrals.Signup');
  require('sections/referrals/Podio.UI.Referrals.Teaser');
  require('sections/referrals/Podio.UI.Referrals.Landing');

});

